// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"235":"0cad11a1","627":"366b36c9","729":"c488c277","736":"662b7ac0"}[chunkId] + ".chunk.css";
};